<template>
    <v-card width="400px"
            height="230px"
            style="margin-left: 20px; margin-right: 20px"
            :style="'border-color:' + primaryColor + '!important'"
            class="d-table-cell align-middle add-room-card text-center mb-5 mt-5">
        <div class="d-inline-block w-100 room-card-box">
            <v-btn color="rgb(33, 158, 185)"
                   text
                   class="text-none add-room-btn"
                   :color="primaryColor"
                   style="border-radius: 20px"
                   @click="openModal">
                <v-icon class="mr-2">add</v-icon>
                Ajouter un contact
            </v-btn>
        </div>
    </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"

export default {
    name: "AddButton",
    methods: {
        ...mapMutations("web_form", ["setAddApidaeContactDialog", "setCurrentApidaeContact"]),
        openModal() {
            let contact = {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                profession: null,
                phone_2: null,
                address: null,
                commune: null,
                postal_code: null,
                province: null,
            }

            contact.uid = Math.random().toString(36).substr(2, 16)

            this.setCurrentApidaeContact(contact)
            this.setAddApidaeContactDialog(true)
        },
    },
    computed: {
        ...mapState("webFormStyle", ["primaryColor"]),
    },
}
</script>